export default function TimesIcon() {
  return (
    <svg viewBox="0 0 8.4666666 8.4666666" xmlns="http://www.w3.org/2000/svg">
      <path d="M 0.09152185,0.09152185 8.3751448,8.3751448" strokeWidth="1.2" />
      <path d="M 0.09152185,8.3751449 8.3751448,0.09152185" strokeWidth="1.2" />
    </svg>
  );
}
